.space {
  display: flex;
}

.wrap {
  flex-wrap: wrap;
}
